import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Client } from '@shared/models/client/client.class';
import { MatRipple } from '@angular/material/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'client-image',
    templateUrl: './client-image.component.html',
    styleUrls: ['./client-image.component.scss'],
    imports: [MatRipple, NgClass]
})
export class ClientImageComponent {
  @ViewChild('upload', {static: false}) upload: any;
  @Input() activeProgress: boolean = false;

  @Output() uploadHandler: EventEmitter<any> = new EventEmitter<any>();

  defaultClientIcon: string = './../../../../../assets/core/dummy.png';

  @Input() set client(val: Client) {
    this._client = val;
  }

  _client: Client;

  uploadOpen(event: any) {
    this.uploadHandler.emit(event);
    setTimeout(() => {
      this.upload.nativeElement.value = '';
    }, 1000);
  }

  upLoad() {
    this.upload.nativeElement.click();
  }

  getClientImage(): string {
    return this._client ? this._client.icon ? this._client.icon : this.defaultClientIcon : this.defaultClientIcon;
  }

}
